import {
  api_LoadFrequentryBoughtProductListToMemory,
  api_LoadCategoryAndProductListToMemory,
  api_UpdateRunningSaleOrderMemory,
  api_LoadMerchantInfoListToMemory,
  api_LoadMobileSettingsToMemory,
  api_WriteMemoryDataForTesting,
  api_LoadMapLocationsToMemmory,
  api_LoadMobileUrlToMemmory,
  api_UpdateAllToMemory,
  api_LoadPromoToMemory,
  api_LoadZoneToMemory,
} from "../../connection/api/api-update-memory";
import { CONCAT_TEXT_LIMIT, HEADER_TAB_SETUP } from "../../functions/funtion";
import { ToastMessage } from "../../components/toast-notification/toast";
import { PT_CONFIGURE } from "../../routes/stack/paths/pt-home";
import { CSP } from "../../config/config";
import React from "react";
import "../../styles/css/pg-settings.css";

export default class Settings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isProcessing: false,
    };
  }

  async componentDidMount() {
    await HEADER_TAB_SETUP({
      HeaderTabName: CONCAT_TEXT_LIMIT({
        length: 20,
        string: "Settings",
      }),
      FnGoBackScreen: () => {
        this.props.navigate(PT_CONFIGURE.replace(":csp", CSP));
      },
      HeaderNavigatorMenuDisplay: false,
      FnHeaderNavigatorMenu: () => {},
    });
  }

  handleButtonClick = async (apiFunction) => {
    const { isProcessing } = this.state;

    if (isProcessing) {
      return;
    }

    this.setState({ isProcessing: true });

    const result = await apiFunction();
    // Alert.MessageBox({
    //   Tittle: "Info",
    //   ConfirmButtonText: "Ok",
    //   Text: result,
    // });
    ToastMessage(1, result);

    this.setState({ isProcessing: false });
  };

  render() {
    const { isProcessing } = this.state;

    return (
      <div
        style={{
          backgroundColor: "#f0f0f0",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingTop: "15%",
          paddingBottom: "10%",
        }}
      >
        {isProcessing ? (
          <button className="disableBtn" disabled>
            <i className="fa fa-circle-o-notch fa-spin"></i>
          </button>
        ) : (
          <button
            className="bbutton"
            onClick={() => this.handleButtonClick(api_UpdateAllToMemory)}
            disabled={isProcessing}
          >
            Update All To Memory
          </button>
        )}

        <br />

        {isProcessing ? (
          <button className="disableBtn" disabled>
            <i className="fa fa-circle-o-notch fa-spin"></i>
          </button>
        ) : (
          <button
            className="bbutton"
            onClick={() =>
              this.handleButtonClick(api_LoadMobileSettingsToMemory)
            }
            disabled={isProcessing}
          >
            Load Mobile Settings To Memory
          </button>
        )}

        <br />

        {isProcessing ? (
          <button className="disableBtn" disabled>
            <i className="fa fa-circle-o-notch fa-spin"></i>
          </button>
        ) : (
          <button
            className="bbutton"
            onClick={() =>
              this.handleButtonClick(api_LoadMerchantInfoListToMemory)
            }
            disabled={isProcessing}
          >
            Load Merchant Info List To Memory
          </button>
        )}
        <br />

        {isProcessing ? (
          <button className="disableBtn" disabled>
            <i className="fa fa-circle-o-notch fa-spin"></i>
          </button>
        ) : (
          <button
            className="bbutton"
            onClick={() =>
              this.handleButtonClick(api_LoadCategoryAndProductListToMemory)
            }
            disabled={isProcessing}
          >
            Load Category And Product List To Memory
          </button>
        )}

        <br />

        {isProcessing ? (
          <button className="disableBtn" disabled>
            <i className="fa fa-circle-o-notch fa-spin"></i>
          </button>
        ) : (
          <button
            className="bbutton"
            onClick={() =>
              this.handleButtonClick(api_UpdateRunningSaleOrderMemory)
            }
            disabled={isProcessing}
          >
            Update Running Sale Order To Memory
          </button>
        )}

        <br />

        {isProcessing ? (
          <button className="disableBtn" disabled>
            <i className="fa fa-circle-o-notch fa-spin"></i>
          </button>
        ) : (
          <button
            className="bbutton"
            onClick={() =>
              this.handleButtonClick(
                api_LoadFrequentryBoughtProductListToMemory,
              )
            }
            disabled={isProcessing}
          >
            Load Frequently Bought Product List To Memory
          </button>
        )}

        <br />

        {isProcessing ? (
          <button className="disableBtn" disabled>
            <i className="fa fa-circle-o-notch fa-spin"></i>
          </button>
        ) : (
          <button
            className="bbutton"
            onClick={() => this.handleButtonClick(api_LoadZoneToMemory)}
            disabled={isProcessing}
          >
            Load Zone To Memory
          </button>
        )}

        <br />

        {isProcessing ? (
          <button className="disableBtn" disabled>
            <i className="fa fa-circle-o-notch fa-spin"></i>
          </button>
        ) : (
          <button
            className="bbutton"
            onClick={() =>
              this.handleButtonClick(api_LoadMapLocationsToMemmory)
            }
            disabled={isProcessing}
          >
            Load Map Locations To Memmory
          </button>
        )}

        <br />

        {isProcessing ? (
          <button className="disableBtn" disabled>
            <i className="fa fa-circle-o-notch fa-spin"></i>
          </button>
        ) : (
          <button
            className="bbutton"
            onClick={() => this.handleButtonClick(api_LoadPromoToMemory)}
            disabled={isProcessing}
          >
            Load Promo To Memory
          </button>
        )}

        <br />

        {isProcessing ? (
          <button className="disableBtn" disabled>
            <i className="fa fa-circle-o-notch fa-spin"></i>
          </button>
        ) : (
          <button
            className="bbutton"
            onClick={() => this.handleButtonClick(api_LoadMobileUrlToMemmory)}
            disabled={isProcessing}
          >
            Load Mobile Url To Memmory
          </button>
        )}

        <br />

        {isProcessing ? (
          <button className="disableBtn" disabled>
            <i className="fa fa-circle-o-notch fa-spin"></i>
          </button>
        ) : (
          <button
            className="bbutton"
            disabled={isProcessing}
            onClick={() =>
              this.handleButtonClick(api_WriteMemoryDataForTesting)
            }
          >
            Write Memory Data For Testing
          </button>
        )}
      </div>
    );
  }
}
